import { ChangeDetectionStrategy, Component, input } from '@angular/core'

export interface ProductionLinePaths {
  workCenterNumbers: string[]
}

@Component({
  selector: 'app-production-line-path',
  imports: [],
  template: `
    @if (productionLinePaths().workCenterNumbers; as workCenterNumbers) {
      <div class="layout-row gap-sm">
        @for (workCenterNumber of workCenterNumbers; track $index) {
          <div class="segment">
            <span class="mat-caption mx-sm">{{ workCenterNumber }}</span>
          </div>
        }
      </div>
    }
  `,
})
export class ProductionLinePathComponent {
  readonly productionLinePaths = input.required<ProductionLinePaths>()
}
